var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReversal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "swap",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 473.36,
    viewBox: "0 0 512 473.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    "data-name": "Path 4196",
    d: "M419.31,216a16.006,16.006,0,0,1-22.62,0L376,195.31a16.006,16.006,0,0,1,0-22.62L396.69,152H112a48.051,48.051,0,0,0-48,48,24.032,24.032,0,0,1-24,24H24A24.032,24.032,0,0,1,0,200,112.123,112.123,0,0,1,112,88H396.69L376,67.31a16.006,16.006,0,0,1,0-22.62L396.69,24a16.006,16.006,0,0,1,22.62,0l90.35,90.34a8.015,8.015,0,0,1,0,11.32Z",
    transform: "translate(0 -19.32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    "data-name": "Path 4197",
    d: "M92.69,296a16.006,16.006,0,0,1,22.62,0L136,316.69a15.975,15.975,0,0,1,0,22.62L115.31,360H400a48.051,48.051,0,0,0,48-48,24.032,24.032,0,0,1,24-24h16a24.032,24.032,0,0,1,24,24A112.123,112.123,0,0,1,400,424H115.31L136,444.69a15.975,15.975,0,0,1,0,22.62L115.31,488a16.005,16.005,0,0,1-22.62,0L2.34,397.66a8.015,8.015,0,0,1,0-11.32Z",
    transform: "translate(0 -19.32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReversal);
export default __webpack_public_path__ + "static/media/reversal.e1dc9f955752346583f769fa2c2ab8b1.svg";
export { ForwardRef as ReactComponent };